export const resolveCircuitBoardPort = (circuitBoardPort: string): number => {
  const number = parseInt(circuitBoardPort, 10)
  return !isNaN(number) ? number : 0
}
